import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {notification, Popover, Progress, Radio, Upload} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import UpLoad from './UpLoad';



export default class MyUpLoad  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            newArrayFileList:[],
            resourceType:0,//文件库
            loading: false
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {

        return(
                <UpLoad type={this.props.UpLoadType}
                        ref={(upload) => {
                            this.upload = upload
                        }}
                        fileList={this.state.newArrayFileList}
                        id={this.props.currentId}
                        resourceName={this.props.resourceName}
                        IsTile={this.props.IsTile}
                        showPercent={false}
                        text={'上传'}
                        Top={'0px'}
                        right={'5px'}
                        color={true}
                        callBack={(data,IsRefresh)=>{
                            this.setState({newArrayFileList:data},()=>{
                                if (IsRefresh){
                                    this.props.callBack&&this.props.callBack();
                                }
                                this.props.uplodCallBack&&this.props.uplodCallBack(data)
                            })
                        }}
                        fileError={(md5)=>{
                            this.state.newArrayFileList.forEach(item=>{
                                if(item.originFileObj){
                                    if(md5===item.originFileObj.md5){
                                        item.status='error';
                                        this.setState({})
                                    }
                                }
                            })
                        }}
                        updateFileList={(newFileList)=>this.setState({newArrayFileList:newFileList})}
                />
        )
    }

    cancelUpload(file){
        this.upload.cancelUpload(file)
    }
}
